/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_04_TitleInputs */

const en_landing_section_04_title = /** @type {(inputs: Landing_Section_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Career magic starts here.`)
};

const de_landing_section_04_title = /** @type {(inputs: Landing_Section_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karriere-Magie beginnt hier.`)
};

const fr_landing_section_04_title = /** @type {(inputs: Landing_Section_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Career magic starts here.`)
};

const es_landing_section_04_title = /** @type {(inputs: Landing_Section_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Career magic starts here.`)
};

const it_landing_section_04_title = /** @type {(inputs: Landing_Section_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Career magic starts here.`)
};

const nl_landing_section_04_title = /** @type {(inputs: Landing_Section_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Career magic starts here.`)
};

const pl_landing_section_04_title = /** @type {(inputs: Landing_Section_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Career magic starts here.`)
};

const fi_landing_section_04_title = /** @type {(inputs: Landing_Section_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Career magic starts here.`)
};

const da_landing_section_04_title = /** @type {(inputs: Landing_Section_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Career magic starts here.`)
};

const sv_landing_section_04_title = /** @type {(inputs: Landing_Section_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Career magic starts here.`)
};

/**
* | output |
* | --- |
* | "Career magic starts here." |
*
* @param {Landing_Section_04_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_04_title = /** @type {((inputs?: Landing_Section_04_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_04_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_04_title(inputs)
	if (locale === "fr") return fr_landing_section_04_title(inputs)
	if (locale === "es") return es_landing_section_04_title(inputs)
	if (locale === "it") return it_landing_section_04_title(inputs)
	if (locale === "nl") return nl_landing_section_04_title(inputs)
	if (locale === "pl") return pl_landing_section_04_title(inputs)
	if (locale === "fi") return fi_landing_section_04_title(inputs)
	if (locale === "da") return da_landing_section_04_title(inputs)
	if (locale === "sv") return sv_landing_section_04_title(inputs)
	return en_landing_section_04_title(inputs)
});